import React, { useState, useEffect } from 'react';
import Loader from '../../../../components/Loader/Loader';
import axios from 'store/axios/axios-ertl';
import { formatUTCtoPST, handleError } from '../../../../shared/utility';
import Notification from '../../../../components/Notification/Notification';
import ReactTable from "react-table";
import { IconButton } from '@material-ui/core';
import { ERTLStatusDescriptions } from '../../../ERTL/FormWizard/ERTLModel';
import Button from '../../../../components/CustomButtons/Button';
import { getUser } from '../../../../shared/authValidation';

const ERTLSubTab = (props) => {
    const [entries, setEntries] = useState([]);
    const [loading, setLoading] = useState(false);
    const [notification, setNotification] = useState('');
    const { permsAll, perms } = props;

    const loadERTL = async () => {
        setLoading(true);
        try {
            const response = await axios.get('/entries?property_id='+props.property_id);
            console.log('loading', response.data);
            if (!response.data) throw "Could not load ERTL";
            setEntries(response.data);
            setLoading(false);
        } catch(e) {
            handleError(e);
            setNotification('Could not load ERTL, please try again.');
            setLoading(false);
        }
    }

    const loadERTLEntry = async () => {
        setLoading(true);
        try {
            const response = await axios.get('/entry?property_id='+props.property_id);
            console.log('loading', response.data);
            if (!response.data) throw "Could not load ERTL";
            setEntries(response.data);
            setLoading(false);
        } catch(e) {
            handleError(e);
            setNotification('Could not load ERTL, please try again.');
            setLoading(false);
        }
    }

    useEffect(() => {
        loadERTL();
    }, []);

    const defaultSorted = props.defaultSorted
        ? props.defaultSorted
        : [
              {
                  id: "date",
                  desc: true,
              },
          ];

    const columns = [
        {
            Header: "ID #",
            accessor: "id" 
        },
        {
            Header: "Date Created",
            accessor: "created_date"
        },
        {
            Header: "Date Modified",
            accessor: "modified_date"
        },
        {
            Header: "Status",
            accessor: "status"
        },
        {
            Header: "Submitter",
            accessor: "name"
        },
        {
            Header: "Actions",
            accessor: "actions"
        }
    ]

    console.log('ERTLSubTab', props);

    const usr = getUser();

    return (
        <div>
            {permsAll.indexOf('ERTL fill form') !== -1 &&
                                <Button color="primary"
                                    onClick={() => {
                                        window.location.href = '/ertl?p=new&property_id='+props.property_id;
                                    }}
                                >Create New ERTL</Button>}

            {loading && <Loader center={true} /> }

            {entries.length === 0 && <p>No ERTL.</p>}

            <div className="react-table-hover-gray">
                <ReactTable
                    defaultSorted={defaultSorted}
                    data={entries.map(entry => {
                        //
                        // 0: 'Draft', // My Drafts tab
                        // 1: 'Pending Owner Approval', // Pending To Review tab
                        // 2: 'Pending Docusign Signature', // Pending tab
                        // 7: 'Pending Level 1 Approver', // Pending tab - Level 1 Approver
                        // 8: 'Rejected by Level 1 Approver', // Pending tab -  Level 1 Approver
                        // 3: 'Pending Final Approver Signature', // Pending Final Approver
                        // 4: 'Approved by Final Approver/Signed', // Completed tab - Fully Executed
                        // 9: 'Rejected by Final Approver',
                        // 5: 'Owner Declined',
                        // 6: 'Modified by Approver'
                        let href = '';
                        if (usr.id === entry.user_id) {
                            // OWNER 
                            if (entry.status === 0) {
                                href = '/ertl?p=open&property_id='+props.property_id+'&ertl_id='+entry.id;
                            }
                        }
                        if (entry.status === 4) {
                            href = '/ertl?p=open&property_id='+props.property_id+'&ertl_id='+entry.id;
                        }
                        return {
                            id: entry.id,
                            created_date: formatUTCtoPST(entry.created_date),
                            modified_date: formatUTCtoPST(entry.modified_date),
                            status: ERTLStatusDescriptions[entry.status] ? ERTLStatusDescriptions[entry.status] : '',
                            name: entry.name,
                            actions: <div>
                                {href && <IconButton
                                    onClick={() => {
                                        window.location.href = href;
                                    }}
                                >
                                    <i className="fa fa-eye"></i>
                                </IconButton>}
                            </div>
                        }
                    })}
                    className="-striped"
                    showPaginationTop
                    showPaginationBottom
                    columns={columns}
                    resizable
                    defaultPageSize={10}
                    pageSizeOptions={[10, 20, 30]}
                    minRows={10}
                    filterable
                />
            </div>

            {notification && <Notification 
                open={true}
                close={() => {
                    setNotification('');
                }}
                message={notification}
            />}
        </div>
    );
};

export default ERTLSubTab;
